import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Navbar from "../Components/Navbar";
import logo from "../Assets/logo.png";
import { IoIosArrowBack } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import io from "socket.io-client";
import axios from "axios";
import { AuthContext } from "../hooks/useLogin";
import { toast } from "react-toastify";

const socket = io("https://inaaniserver-50c4305cc7f7.herokuapp.com");

const Inbox = () => {
  const { user } = useContext(AuthContext);
  const [selectedChat, setSelectedChat] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [hoveredMessage, setHoveredMessage] = useState(null);
  const [showDelete, setShowDelete] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [availableAdmins, setAvailableAdmins] = useState([]);

  const userId = user?.id;
  const [adminId, setAdminId] = useState(null);

  const fetchAdmins = async () => {
  if (!userId) return;
  try {
    const convResponse = await axios.get(`https://inaaniserver-50c4305cc7f7.herokuapp.com/inbox/conversation/${userId}`);
    console.log("Fetched conversations:", JSON.stringify(convResponse.data, null, 2));
    if (convResponse.data.error) {
      throw new Error(convResponse.data.message);
    }
    const conversations = Array.isArray(convResponse.data) ? convResponse.data : [];
    console.log("Parsed conversations:", JSON.stringify(conversations, null, 2));

    const response = await axios.get("https://inaaniserver-50c4305cc7f7.herokuapp.com/users/admins");
    console.log("Fetched admins:", JSON.stringify(response.data, null, 2));
    if (response.data.error) {
      throw new Error(response.data.message);
    }
    const adminData = Array.isArray(response.data.data) ? response.data.data : [];
    console.log("Parsed adminData:", JSON.stringify(adminData, null, 2));

    const formattedAdmins = adminData
      .map((admin, index) => {
        const conversation = conversations.find(
          (conv) =>
            (conv.user1_id === parseInt(userId) && conv.user2_id === admin.id) ||
            (conv.user2_id === parseInt(userId) && conv.user1_id === admin.id)
        );
        console.log(`Admin ${admin.id} conversation:`, conversation);
        if (!conversation) return null;
        return {
          conversation_id: conversation.conversation_id || `temp-${admin.id}`,
          name: admin.fullname || `Admin ${admin.id}`,
          role: "Administrator",
          preview: conversation.latest_message || "No messages yet",
          unread_count: Number(conversation.unread_count) || 0,
          recency: conversation.transdate
            ? (() => {
                const transdate = new Date(conversation.transdate);
                const now = new Date();
                const diffMs = now - transdate;
                const diffMins = Math.floor(diffMs / (1000 * 60));
                return diffMins < 1
                  ? "Just now"
                  : diffMins < 60
                  ? `${diffMins}m`
                  : diffMins < 1440
                  ? `${Math.floor(diffMins / 60)}h`
                  : `${Math.floor(diffMins / 1440)}d`;
              })()
            : "",
          recipientId: admin.id,
          key: `admin-${admin.id}-${index}`,
        };
      })
      .filter((admin) => admin !== null);
    console.log("Final formatted admins:", JSON.stringify(formattedAdmins, null, 2));
    setAdmins(formattedAdmins);
  } catch (error) {
    console.error("Error fetching admins:", error.response?.data || error.message);
    toast.error("Failed to load conversations, please try again");
    // Don't clear admins, keep existing state
  }
};

  const fetchAvailableAdmins = async () => {
    try {
      const response = await axios.get("https://inaaniserver-50c4305cc7f7.herokuapp.com/users/admins");
      console.log("Fetched available admins:", response.data);
      if (response.data.error) {
        throw new Error(response.data.message);
      }
      const adminData = response.data.data || [];
      console.log("Available adminData:", adminData);
      if (!Array.isArray(adminData)) {
        console.warn("Available adminData is not an array:", adminData);
        throw new Error("Invalid admin data format");
      }
      const formattedAdmins = adminData.map((admin, index) => ({
        recipientId: admin.id,
        name: admin.fullname || `Admin ${admin.id}`,
        role: "Administrator",
        conversation_id: null,
        key: `available-admin-${admin.id}-${index}`
      }));
      console.log("Available formatted admins:", formattedAdmins);
      setAvailableAdmins(formattedAdmins);
    } catch (error) {
      console.error("Error fetching available admins:", error.response?.data || error.message);
      setAvailableAdmins([]);
      toast.error(error.message || "Failed to load available administrators");
    }
  };

  const handleOpenModal = () => {
    fetchAvailableAdmins();
    setShowModal(true);
  };

  const handleSelectNewAdmin = (admin) => {
    handleSelectChat(admin);
    setShowModal(false);
  };

  useEffect(() => {
    if (userId) {
      console.log("Current userId:", userId);
      fetchAdmins();
    }
  }, [userId, fetchAdmins]);

  useEffect(() => {
    if (!userId) return;
    socket.emit("join", userId);
    console.log(`User ${userId} joined Socket.IO room`);
    socket.on(`message_${userId}`, (msgData) => {
      console.log("Received socket.io message:", msgData);
      if (msgData.conversation_id === selectedChat?.conversation_id) {
        setMessages((prevMessages) => [...prevMessages, msgData]);
      }
      fetchAdmins();
    });
    return () => {
      socket.off(`message_${userId}`);
    };
  }, [selectedChat, userId, fetchAdmins]);

  const fetchMessages = async (conversationId) => {
    if (!conversationId) return;
    try {
      const response = await axios.get(`https://inaaniserver-50c4305cc7f7.herokuapp.com/inbox/messages/${conversationId}`);
      console.log("Fetched messages:", response.data);
      setMessages(response.data);
    } catch (error) {
      console.error("Error fetching messages:", error.response?.data || error.message);
      toast.error("Failed to load messages");
    }
  };

  const handleSelectChat = async (admin) => {
    console.log("Selected admin:", admin);
    setSelectedChat(admin);
    setAdminId(admin.recipientId);
    try {
      if (admin.conversation_id) {
        await fetchMessages(admin.conversation_id);
        if (admin.unread_count > 0) {
          const response = await axios.get(`https://inaaniserver-50c4305cc7f7.herokuapp.com/inbox/messages/${admin.conversation_id}`);
          const unreadMessages = response.data.filter(
            (msg) => msg.received_id === userId && msg.is_read === 0
          );
          await Promise.all(unreadMessages.map((msg) => markAsRead(msg.id)));
          fetchAdmins();
        }
      } else {
        setMessages([]);
      }
    } catch (error) {
      console.error("Error handling chat selection:", error);
      toast.error("Error loading chat");
    }
  };

  const sendMessage = async () => {
  if (newMessage.trim() === "" || !adminId) return;
  try {
    let conversationId = selectedChat?.conversation_id;
    if (!conversationId) {
      const response = await axios.post("https://inaaniserver-50c4305cc7f7.herokuapp.com/inbox/add", {
        user1_id: parseInt(userId),
        user2_id: parseInt(adminId),
      });
      console.log("New conversation created:", response.data);
      if (response.data.error) {
        throw new Error(response.data.message);
      }
      conversationId = response.data.conversation_id;
      setSelectedChat({ ...selectedChat, conversation_id: conversationId });
    }
    const messageData = {
      user_id: parseInt(userId),
      admin_id: parseInt(adminId),
      message: newMessage,
    };
    const response = await axios.post("https://inaaniserver-50c4305cc7f7.herokuapp.com/inbox/send", messageData);
    console.log("Message sent:", response.data);
    if (response.data.error) {
      throw new Error(response.data.message);
    }
    setNewMessage("");
    setShowDelete(null);
    await fetchAdmins(); // Refresh conversation list
    if (conversationId) {
      await fetchMessages(conversationId);
    }
  } catch (error) {
    console.error("Error sending message:", error.response?.data || error.message);
    toast.error(error.message || "Failed to send message");
  }
};

  const markAsRead = async (messageId) => {
    try {
      await axios.put(`https://inaaniserver-50c4305cc7f7.herokuapp.com/inbox/read/${messageId}`);
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          msg.id === messageId ? { ...msg, is_read: 1 } : msg
        )
      );
      fetchAdmins();
    } catch (error) {
      console.error("Error marking message as read:", error.response?.data || error.message);
      toast.error("Error marking message as read");
    }
  };

  const deleteMessage = async (messageId, index) => {
    try {
      await axios.delete(`https://inaaniserver-50c4305cc7f7.herokuapp.com/inbox/delete/${messageId}`);
      setMessages((prevMessages) => prevMessages.filter((_, i) => i !== index));
      toast.success("Message deleted");
    } catch (error) {
      console.error("Error deleting message:", error.response?.data || error.message);
      toast.error("Failed to delete message");
    }
  };

  if (!userId) {
    return <div>Please log in to view your inbox.</div>;
  }

  return (
    <>
      <Navbar
        activeSection="inbox"
        onHomeClick={() => console.log("Home clicked")}
        onMarketplaceClick={() => console.log("Marketplace clicked")}
        onAboutClick={() => console.log("About clicked")}
        onFaqsClick={() => console.log("FAQs clicked")}
      />
      <InboxContainer>
        <MessagesList>
          <SidebarHeader>Administrators</SidebarHeader>
          <NewMessageButton onClick={handleOpenModal}>
            <FaPlus /> New Message
          </NewMessageButton>
          {admins.length > 0 ? (
            admins.map((admin) => (
              <MessageItem
                key={admin.key || admin.recipientId}
                onClick={() => handleSelectChat(admin)}
              >
                <Avatar>
                  <img src={logo} alt={admin.name} />
                </Avatar>
                <MessagePreview>
                  <strong>{admin.name}</strong>
                  <RoleLabel>Administrator</RoleLabel>
                  <span>{admin.preview}</span>
                  <Timestamp>{admin.recency}</Timestamp>
                  {admin.unread_count > 0 && <UnreadDot />}
                </MessagePreview>
              </MessageItem>
            ))
          ) : (
            <NoConversations>No conversations available</NoConversations>
          )}
        </MessagesList>
        {selectedChat ? (
          <ChatInterface>
            <ChatHeader>
              <BackIcon onClick={() => setSelectedChat(null)}>
                <IoIosArrowBack />
              </BackIcon>
              <ChatTitle>
                {selectedChat.name} <RoleLabel>Administrator</RoleLabel>
              </ChatTitle>
              <HeaderOptions>...</HeaderOptions>
            </ChatHeader>
            <ChatBody>
              {Array.isArray(messages) && messages.length > 0 ? (
                messages.map((msg, index) => (
                  <ChatMessage
                    key={msg.id || index}
                    isUser={msg.sender_id === userId}
                    onMouseEnter={() => setHoveredMessage(index)}
                    onMouseLeave={() => setHoveredMessage(null)}
                  >
                    <Avatar>
                      <img src={logo} alt="User" />
                    </Avatar>
                    <MessageBubble isUser={msg.sender_id === userId}>
                      {msg.messages || msg.message}
                      <MessageTimestamp isUser={msg.sender_id === userId}>
                        {new Date(msg.transdate).toLocaleTimeString([], {
                          hour: "numeric",
                          minute: "2-digit",
                        })}
                      </MessageTimestamp>
                      {msg.is_read === 0 && msg.sender_id === userId && (
                        <ReadStatus isUser={msg.sender_id === userId}>
                          Unread
                        </ReadStatus>
                      )}
                    </MessageBubble>
                    {msg.sender_id === userId && (
                      <MessageOptions
                        onClick={() =>
                          setShowDelete(showDelete === index ? null : index)
                        }
                        style={{
                          visibility:
                            hoveredMessage === index ? "visible" : "hidden",
                        }}
                      >
                        ⋮
                      </MessageOptions>
                    )}
                    {showDelete === index && (
                      <DeleteButton
                        onClick={() => deleteMessage(msg.id, index)}
                      >
                        <MdDelete />
                      </DeleteButton>
                    )}
                  </ChatMessage>
                ))
              ) : (
                <div>No messages to display</div>
              )}
            </ChatBody>
            <ChatInputContainer>
              <ChatInput
                type="text"
                placeholder="Send message..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && sendMessage()}
              />
              <SendButton onClick={sendMessage}>Send</SendButton>
            </ChatInputContainer>
          </ChatInterface>
        ) : (
          <NoChatSelected>
            Select an administrator to start chatting
          </NoChatSelected>
        )}
      </InboxContainer>
      {showModal && (
        <ModalOverlay>
          <ModalContent>
            <ModalHeader>
              <h2>Select Administrator</h2>
              <CloseButton onClick={() => setShowModal(false)}>×</CloseButton>
            </ModalHeader>
            <ModalBody>
              {availableAdmins.length > 0 ? (
                availableAdmins.map((admin) => (
                  <AdminItem
                    key={admin.key || admin.recipientId}
                    onClick={() => handleSelectNewAdmin(admin)}
                  >
                    <strong>{admin.name}</strong>
                    <RoleLabel>Administrator</RoleLabel>
                  </AdminItem>
                ))
              ) : (
                <div>No administrators available</div>
              )}
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default Inbox;

// Styled components (unchanged)
const RoleLabel = styled.span`
  font-size: 0.7rem;
  color: #004d00;
  font-weight: normal;
  margin-left: 0.5rem;
  vertical-align: middle;
  display: inline-block;
`;

const NoConversations = styled.div`
  text-align: center;
  color: #888888;
  padding: 1rem;
`;

const SidebarHeader = styled.h2`
  font-size: 1.5rem;
  color: #004d00;
  margin: 0 0 0.5rem 0;
  padding: 0.5rem;
  text-align: center;
  background-color: #f0f0f0;
  border-bottom: 1px solid #e5e5e5;
`;

const NewMessageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 1rem;
  border: none;
  background-color: #004d00;
  color: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  svg {
    margin-right: 0.5rem;
  }
  &:hover {
    background-color: #003300;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 8px;
  width: 300px;
  max-height: 400px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e5e5e5;
  background-color: #f0f0f0;
  h2 {
    margin: 0;
    font-size: 1.2rem;
    color: #004d00;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #004d00;
  &:hover {
    color: #003300;
  }
`;

const ModalBody = styled.div`
  padding: 1rem;
`;

const AdminItem = styled.div`
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    background-color: #e0f7e0;
  }
  strong {
    color: #004d00;
  }
`;

const InboxContainer = styled.div`
  display: flex;
  height: calc(100vh - 80px);
  font-family: Arial, sans-serif;
`;

const MessagesList = styled.div`
  width: 350px;
  border-right: 1px solid #e5e5e5;
  padding: 1rem;
  background-color: #f9f9f9;
  overflow-y: auto;
`;

const MessageItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s;
  position: relative;
  &:hover {
    background-color: #e0f7e0;
  }
`;

const Avatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 1rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MessagePreview = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  font-size: 0.9rem;
  position: relative;
  strong {
    font-size: 1.1rem;
    color: #004d00;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }
  span {
    color: #888888;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }
`;

const ChatInterface = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`;

const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: #f0f0f0;
  border-bottom: 1px solid #e5e5e5;
`;

const BackIcon = styled.div`
  cursor: pointer;
  font-size: 1.5rem;
  color: #004d00;
`;

const ChatTitle = styled.h2`
  font-size: 1.2rem;
  color: #004d00;
  margin: 0;
  display: flex;
  align-items: center;
`;

const HeaderOptions = styled.div`
  cursor: pointer;
  font-size: 1rem;
  color: #004d00;
`;

const ChatBody = styled.div`
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
`;

const ChatMessage = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  align-self: ${(props) => (props.isUser ? "flex-end" : "flex-start")};
  cursor: pointer;
`;

const MessageBubble = styled.div`
  background: ${(props) => (props.isUser ? "#004d00" : "#e0ffe0")};
  color: ${(props) => (props.isUser ? "white" : "#004d00")};
  padding: 10px 15px;
  border-radius: 15px;
  max-width: 60%;
  word-wrap: break-word;
  position: relative;
  margin-left: ${(props) => (props.isUser ? "auto" : "0")};
  margin-right: ${(props) => (props.isUser ? "0" : "auto")};
`;

const MessageTimestamp = styled.span`
  font-size: 0.75rem;
  color: ${(props) =>
    props.isUser ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 77, 0, 0.7)"};
  display: block;
  margin-top: 5px;
  text-align: ${(props) => (props.isUser ? "right" : "left")};
`;

const ReadStatus = styled.span`
  font-size: 0.65rem;
  color: ${(props) =>
    props.isUser ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 77, 0, 0.5)"};
  display: block;
  margin-top: 2px;
  text-align: ${(props) => (props.isUser ? "right" : "left")};
`;

const ChatInputContainer = styled.div`
  padding: 1rem;
  border-top: 1px solid #e5e5e5;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
`;

const ChatInput = styled.input`
  width: 85%;
  padding: 0.8rem;
  border: 1px solid #cccccc;
  border-radius: 20px;
  font-size: 1rem;
  outline: none;
  &:focus {
    border-color: rgb(22, 173, 22);
  }
`;

const SendButton = styled.button`
  padding: 0.8rem 1.5rem;
  border: none;
  background-color: #004d00;
  color: #ffffff;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  &:hover {
    background-color: #003300;
  }
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  font-size: 1.2rem;
  margin-left: 10px;
  display: flex;
  align-items: center;
  &:hover {
    color: darkred;
  }
`;

const MessageOptions = styled.div`
  cursor: pointer;
  font-size: 1.2rem;
  color: #888;
  margin-left: 8px;
  display: flex;
  align-items: center;
  visibility: hidden;
  &:hover {
    color: #004d00;
  }
`;

const NoChatSelected = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  color: #888888;
  background-color: #f9f9f9;
`;

const UnreadDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: #1a73e8;
  border-radius: 50%;
  position: absolute;
  right: 10px;
  bottom: 10px;
`;

const Timestamp = styled.div`
  position: absolute;
  right: 0;
  top: 0.5rem;
  font-size: 0.8rem;
  color: #888888;
`;